<template>
  <div :class="cssClass" v-click-outside="close">
    <div
      class="c-select__selected"
      :class="{
        'is-disabled': disabled,
        'is-empty': isEmpty,
        'is-readOnly': readOnly
      }"
      @click="toggle"
    >
      <template v-if="disabled || isEmpty">
        {{ placeholder }}
      </template>
      <slot v-else name="selected" :selected="selectedOption">
        {{ selectedOption.label }}
      </slot>
    </div>
    <div
      v-if="!disabled && hasOption"
      class="c-select-options"
      :class="{ 'is-active': isActive }"
      :data-placement="placement"
      @click="close"
    >
      <SelectOption v-if="!required" :selected="selected" @change="change">
        {{ placeholder }}
      </SelectOption>
      <slot>
        <SelectOption
          v-for="(option, index) in options"
          :key="index"
          :option="option"
          :selected="selected"
          @change="change"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import SelectOption from '@/components/SelectOption';
export default {
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: '選択してください'
    },
    placement: {
      type: String,
      required: false,
      default: 'bottom'
    },
    readOnly: {
      type: Boolean,
      required: false
    },
    required: {
      type: Boolean,
      required: false
    },
    selected: {
      type: [Number, String],
      required: true
    },
    size: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false
    }
  },
  components: {
    SelectOption
  },
  data() {
    return {
      isActive: false
    };
  },
  computed: {
    cssClass() {
      return {
        'c-select': true,
        ['c-select--' + this.size]: this.size,
        ['c-select--' + this.variant]: this.variant
      };
    },
    selectedOption() {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].value === this.selected) {
          return this.options[i];
        }
      }
      return false;
    },
    hasOption() {
      return this.options.length ? true : false;
    },
    isEmpty() {
      return !this.selectedOption;
    }
  },
  methods: {
    change(selected) {
      this.$emit('change', selected);
    },
    close() {
      this.isActive = false;
    },
    toggle() {
      this.isActive = !this.isActive;
    }
  }
};
</script>
